// eslint-disable-next-line no-multi-assign
globalThis.Uppy = module.exports = require('.')
